import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';



export default function SystemErrorMessageForDevEnv( { data, errorType, time, code, endpoint, url } ) {
    const  {
        mockData = undefined,
        ssapApplicationId = 'not received',
        manuallyCreated = undefined,
        taxHousehold: {
            bloodRelationship,
            householdMember
        }
    } = data;
    return (
        <Fragment>
            <div className="grid-container gi-grid-container">
                <table className="usa-table gi-table">
                    <thead>
                        <tr>
                            <th scope="col" colSpan="2">
                                <FormattedMessage id='system_err.header' />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row"><FormattedMessage id='system_err.type' /></th>
                            <td>
                                { errorType }
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><FormattedMessage id='system_err.status_code' /></th>
                            <td>
                                { code }
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><FormattedMessage id='system_err.endpoint' /></th>
                            <td>
                                { endpoint }
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><FormattedMessage id='system_err.url' /></th>
                            <td>
                                { url }
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><FormattedMessage id='system_err.ssap_id' /></th>
                            <td>
                                { ssapApplicationId }
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><FormattedMessage id='system_err.ssap_m_created' /></th>
                            <td>
                                { manuallyCreated ? 'TRUE' : 'FALSE' }
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><FormattedMessage id='system_err.ssap_BR' /></th>
                            <td>
                                { bloodRelationship.length }
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><FormattedMessage id='system_err.ssap_HHM' /></th>
                            <td>
                                { mockData ? 0 : householdMember.length }
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><FormattedMessage id='system_err.system_time' /></th>
                            <td>
                                { time }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Fragment>
    );
}